import { createRouter, createWebHistory } from "vue-router";
import store from './../store';
const routes=[
    {
        path:"/",
        name:"home",
        components:{
            default:()=>import("@/views/HomePage.vue")
        }
    },
    {
        path:'/pricing',
        name:"pricing",
        components:{
            default:()=>("./../views/PricingPage.vue")
        }
    },
    {
        path:"/login",
        name:"login",
        components:{
            default:()=>import("@/views/User/LoginPage.vue"),
        }
    }/*,{
        path:"/register",
        name:"register",
        components:{
            default:()=>import("@/views/User/RegisterPage.vue")
        }
    },*/,
    {
        path:'/dashboard',
        name:'dashboard',
        components:{
            default:()=>import("@/views/User/UserView/DashboardPage.vue")
        },
        meta:{
            isAuth:true
        }
    },
    {
        path:"/link/:id",
        name:'linkLog',
        components:{
            default:()=>import("@/views/User/UserView/LinkLogPage.vue")
        },
       
        meta:{
            isAuth:true
        }
    },
    {
        path:'/userlist',
        name:'userlist',
        components:{
            default:()=>import("@/views/User/AdminView/UserPage.vue")
        },
        meta:{
            isAuth:true,
            isAdmin:true,
        }
    },
    {
        path:'/role',
        name:'roleList',
        components:{
            default:()=>import("@/views/User/AdminView/RolePage.vue")
        },
        meta:{
            isAuth:true,
            isAdmin:true,
        }
    }
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
  });
  router.beforeEach(async (to,_,next)=>{
    const user=store.getters['user/getUser'];
    const isAuth=to.meta?.isAuth;
    const isAdmin=to.meta?.isAdmin;
    
    if(isAuth){
        var auth=await store.dispatch('user/AuthControlAsync').then(()=>{
            return true;
          }).catch(()=>{
            store.commit('user/setUser',null);
           return next({name:'home'});
            
          });
        if(user && auth){
            if(!isAdmin)
                next();
            else{
                
                if(isAdmin && user.userRole==="Admin")
                   return next();
                else
                    {
                        return next({name:'home'});
                    }

            }
        }
        else{
            return next({name:'login'});
        }
    }
    if(user){
        if(['login', 'register'].includes(to.name)){
            return next({name:'dashboard'});
        }
    }
    if(!isAuth){
        return next();
    }
  })
  export default router;